import { render, staticRenderFns } from "./ownerFeeHistory.vue?vue&type=template&id=4633805a&scoped=true"
import script from "./ownerFeeHistory.vue?vue&type=script&lang=js"
export * from "./ownerFeeHistory.vue?vue&type=script&lang=js"
import style0 from "./ownerFeeHistory.vue?vue&type=style&index=0&id=4633805a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4633805a",
  null
  
)

export default component.exports